import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import EngineeringIcon from '@mui/icons-material/Engineering';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { DASHBOARD_KEYS } from '../../../../platform/widgets/widgetRegistry.js';
import RoleDashboardPage from './RoleDashboardPage';

/**
 * Individual Contributor Dashboard — Mindmap branch 1, "Individual Team Member"
 *  - Inputs: Drift / Traps / Roadblocks / Landmines with severity; REF actions on OE Conditions
 *  - Sees: NWT dashboard + Site dashboard
 * Widgets (B4): my-submissions, my-nwt-scores, my-site-scores, active-surveys, oe-conditions (mine).
 */
function LogConditionBanner() {
  const navigate = useNavigate();
  return (
    <Card sx={{ mb: 3, bgcolor: 'primary.main', color: 'primary.contrastText' }}>
      <CardContent sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2 }}>
        <Box>
          <Typography variant="h6" fontWeight={700}>
            See Drift, or a Trap, Roadblock, or Landmine in your work?
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.9 }}>
            Log it. It will be routed for review, and the team will decide on Reverse / Eliminate / Fortify actions.
          </Typography>
        </Box>
        <Button
          variant="contained"
          color="secondary"
          size="large"
          startIcon={<AddCircleOutlineIcon />}
          onClick={() => navigate('/drew/rollup/trl-entry')}
          sx={{ fontWeight: 700 }}
        >
          Log an OE Condition
        </Button>
      </CardContent>
    </Card>
  );
}

function ITMDashboard() {
  return (
    <RoleDashboardPage
      dashboardKey={DASHBOARD_KEYS.drewItm}
      hero={{ icon: EngineeringIcon, title: 'Individual Contributor Dashboard', color: '#00897b' }}
      conditions={{ title: 'My OE Conditions', scopeLabel: 'logged by me or assigned to me', defaultFilter: 'mine' }}
      banner={() => <LogConditionBanner />}
    />
  );
}

export default ITMDashboard;
